import React, { useContext } from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import Link from '~/components/link';
import { paths } from '~/../shared/routing';
import Countries from '~/components/countries_enum.ts';
import { getPath } from '~/../shared/utils';
import { LangContext } from '~/components/../providers/LangProvider';

const Breadcrumbs = ({ country }) => {
    const ctxLang = useContext(LangContext);

    return (
        <BreadcrumbsContainer>
            <BreadcrumbsItem>
                <ArticleTitle>
                    <Link
                        href={getPath(paths.blog, ctxLang.state.country)}
                        target="_self"
                    >
                        <Trans id="global.menu.link.blog" />
                    </Link>
                </ArticleTitle>
            </BreadcrumbsItem>
        </BreadcrumbsContainer>
    );
};

export default Breadcrumbs;

const BreadcrumbsContainer = styled.ul`
    display: flex;
    flex-wrap: wrap;
    padding: 0.75rem 1.5rem 1.75rem 0;
    border-radius: 0.25rem;
    list-style: none;
    font-size: 14px;
    letter-spacing: 0.4px;
    color: #1bad93;
`;

const BreadcrumbsItem = styled.li`
    display: inline-flex;

    &:after {
        content: '/';
        padding: 0 0.5rem;
    }

    &:last-child:after {
        content: '';
    }
`;

const ArticleTitle = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    letter-spacing: 0.4px;
    color: #9b9b9b;
`;
